import { DASHBOARD, MEMBER } from '_constants';
import _ from 'lodash';

export const member = (state = {}, action) => {
  let newState = { ...state };
  switch (action.type) {
    case DASHBOARD.FETCH_MEMBER_DATA:
      newState = _.get(action, 'payload.data', {});
      break;
    case MEMBER.SETTING_OUTOFOFFICE:
      newState.outOfOffice = action.payload;
      break;
    case MEMBER.UPDATING_OUTOFOFFICE:
      newState.outOfOffice = action.payload;
      break;
    default:
      break;
  }
  return newState;
};

export function memberData (member) {
  return member;
}
